import React, { useContext, useEffect } from 'react'
import { t } from 'i18next'
import { URL_EXACTIAN, getDataUserByKey, getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../../helpers/helpers'
import EntryAndDepartureReportContext from '../../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext'
import { Spinner } from 'reactstrap'
import { getHourAndMinutesFromSeconds } from '../entryAndDepartureHelper';
import carIcon from '../../../assets/icons/car-black-bk-gray-icon.svg';
import visitIcon from '../../../assets/icons/visit-grey-bk-white-icon.svg';

export const ResourceDetail = ({ resourceInfo, wasEdited }) => {

    const styleTitle = { color: 'var(--gray-800)', fontWeight: '500', fontSize: '12px' }
    const styleSubtitle = { color: 'var(--gray-950)', fontWeight: '500', fontSize: '14px' }

    const { entryAndDepartureReportState, getResourceDetailToReport } = useContext(EntryAndDepartureReportContext);
    const { resourceDetail } = entryAndDepartureReportState;

    const isGuard = Number(getDataUserByKey('access_profile_id')) === 3;

    const haveAccessOpenings = isGuard ? getUserOpening().descripcion !== t('NO_OPENING') : getTenantInfoByKey('is_access_opening');

    const haveAccessBuildings = isGuard ? getUserBuilding().buildingDescription !== t('NO_BUILDING') : getTenantInfoByKey('is_building');

    const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit');

    const {
        resource_id,
        resource_name,
        resource_observations,
        resource_last_name,
        resource_natural_id,
        resource_mail,
        resource_classification,
        contractor_name,
        authorized_by,
        secondsIn
    } = resourceDetail;

    const movementType = resourceDetail?.checkin_movement ? resourceDetail?.checkin_movement : resourceDetail?.checkout_movement;

    const visitTypes = ['VIS', 'VEHVIS'];

    const isEmployeeVehicle = resourceInfo.resource_type === 'VEH';

    const showImgByResource = () => {
        const images = {
            EMP: `${URL_EXACTIAN}Actions/img_proxy.php?idEMP=${resource_id}`,
            VEH: carIcon,
            VIS: visitIcon,
            VEHVIS: carIcon
        }
        return images[resourceInfo.resource_type];
    }

    useEffect(() => {
        getResourceDetailToReport(resourceInfo);
        // eslint-disable-next-line
    }, [wasEdited]);

    return (
        <>
            {
                Object.keys(resourceDetail).length === 0 ?
                    <div className='d-flex justify-content-center align-items-center'>
                        <Spinner />
                    </div>

                    :

                    <div>
                        <div className='d-flex'>
                            <div>
                                <img src={showImgByResource()} style={{ width: '60px', height: '60px' }} alt="profile" />
                            </div>
                            <div className='ms-2'>
                                <p className='m-0' style={{ color: 'var(--gray-950)', fontSize: '16px', fontWeight: '700' }}>
                                    {
                                        resource_name && resource_last_name ?
                                            `${resource_name} ${resource_last_name}`
                                            :
                                            resource_name
                                    }
                                </p>
                                <p className='m-0'>{`${t('ID')} ${resource_natural_id ? resource_natural_id : '-'}`}</p>
                            </div>
                        </div>
                        <div className='p-2 details-grid'>
                            <div className='info-detail-w100'>
                                <p className='m-0' style={styleTitle}>{t('EMAIL')}</p>
                                <p className='m-0' style={styleSubtitle}>{resource_mail ? resource_mail : '-'}</p>
                            </div>

                            <div className='info-detail-w100'>
                                <p className='m-0' style={styleTitle}>{t('RANK')}</p>
                                <p className='m-0' style={styleSubtitle}>{resource_classification ? resource_classification : '-'}</p>
                            </div>

                            <div className='info-detail-w100'>
                                <p className='m-0' style={styleTitle}>{t('CONTRACTOR')}</p>
                                <p className='m-0' style={styleSubtitle}>{contractor_name ? contractor_name : '-'}</p>
                            </div>

                            <div className='info-detail-w100'>
                                <p className='m-0' style={styleTitle}>{t('TIME_ELAPSED')}</p>
                                <p className='m-0' style={styleSubtitle}>{secondsIn ? getHourAndMinutesFromSeconds(secondsIn) : '-'}</p>
                            </div>

                            <div className='info-detail-w100'>
                                <p className='m-0' style={styleTitle}>{t('AUTHORIZED_BY')}</p>
                                <p className='m-0' style={styleSubtitle}>{authorized_by ? authorized_by : '-'}</p>
                            </div>

                            {haveAccessOpenings && (
                                <div className='info-detail-w100'>
                                    <p className='m-0' style={styleTitle}>{getTenantInfoByKey('opening_name')}</p>
                                    <p className='m-0' style={styleSubtitle}>{movementType?.opening_code ? movementType?.opening_code : '-'}</p>
                                </div>
                            )}

                            {haveAccessBuildings && (
                                <>
                                    <div className='info-detail-w100'>
                                        <p className='m-0' style={styleTitle}>{getTenantInfoByKey('building_name')}</p>
                                        <p className='m-0' style={styleSubtitle}>{movementType?.building_id ? movementType?.building_id : '-'}</p>
                                    </div>
                                    {isEmployeeVehicle === false && (
                                        <div className='info-detail-w100'>
                                            <p className='m-0' style={styleTitle}>{getTenantInfoByKey('area_name')}</p>
                                            <p className='m-0' style={styleSubtitle}>{movementType?.area ? movementType?.area : t('FREE_ACCESS_AREA')}</p>
                                        </div>
                                    )}
                                </>
                            )}

                            {havePersonsToVisit && (
                                <div className='info-detail-w100'>
                                    <p className='m-0' style={styleTitle}>{t('PERSON_VISITED')}</p>
                                    <p className='m-0' style={styleSubtitle}>
                                        <div className='d-flex flex-column'>
                                            {
                                                resourceDetail?.people_visited !== null && resourceDetail?.people_visited.length !== 0 ?
                                                    (resourceDetail?.people_visited.map((peopleVisited) =>
                                                        <div
                                                            className='d-flex flex-column'
                                                            key={peopleVisited.people_to_visit_id}
                                                        >
                                                            <span>
                                                                {peopleVisited.document_number} {peopleVisited.name} {peopleVisited.last_name}
                                                            </span>
                                                            {peopleVisited.sector !== null && (
                                                                <span>
                                                                    {peopleVisited.sector.name}
                                                                </span>
                                                            )}
                                                        </div>
                                                    ))
                                                    :
                                                    '-'
                                            }
                                        </div>
                                    </p>
                                </div>
                            )}

                            {visitTypes.includes(resourceInfo.resource_type) ?
                                <div className='info-detail-w100'>
                                    <p className='m-0' style={styleTitle}>{t('REASON')}</p>
                                    <p className='m-0' style={styleSubtitle}>{resource_observations ? resource_observations : '-'}</p>
                                </div>
                                : null
                            }

                            {/*                             <div>
                                <p className='m-0' style={styleTitle}>{t('BUILDING')}</p>
                                <p className='m-0' style={styleSubtitle}>-</p>
                            </div>

                            <div>
                                <p className='m-0' style={styleTitle}>{t('AREA')}</p>
                                <p className='m-0' style={styleSubtitle}>-</p>
                            </div>

                            <div>
                                <p className='m-0' style={styleTitle}>visitó a</p>
                                <p className='m-0' style={styleSubtitle}>Alejandro Castillo</p>
                            </div> */}
                            <div></div>
                        </div>
                    </div >
            }
        </>

    )
}
